import { generateBaseQueryKeysList } from '@/queries/utils';

export const PARTNER_PROVIDERS_KEYS = {
  main: 'partner-providers',
};

export const partnerProvidersQueryKeys = generateBaseQueryKeysList(PARTNER_PROVIDERS_KEYS.main);
